import React from "react";
import styled from "@emotion/styled";

const Button = ({
  variant = "blue", // black, blue, gray, white
  size = "normal", // normal, small
  width,
  disabled,
  children,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      size={size}
      width={width}
      {...props}
      disabled={disabled}
    >
      <ButtonText variant={variant} size={size}>
        {children}
      </ButtonText>
    </StyledButton>
  );
};

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  border-radius: 999px;
  border: none;
  width: ${(props) => props.width && props.width};
  cursor: pointer;
  gap: ${(props) => (props.size === "normal" ? "8px" : "4px")};
  padding: ${(props) => (props.size === "normal" ? "16px 32px" : "8px 16px")};
  background: ${(props) => {
    switch (props.variant) {
      case "white":
        return "rgb(255, 255, 255)";
      case "black":
        return "rgb(33, 37, 67)";
      case "blue":
        return "rgb(97, 98, 197)";
      case "gray":
        return "rgb(241, 245, 249)";
      case "gray-light":
        return "#E2E8F0";
      default:
        return "rgb(33, 37, 67)";
    }
  }};

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background: ${(props) => {
      switch (props.variant) {
        case "white":
          return "rgba(124, 118, 118, 1)";
        case "black":
          return "rgba(211, 213, 222, 1)";
        case "blue":
          return "rgba(136, 136, 142, 1)";
        case "gray":
          return "rgba(89, 91, 93, 1)";
        case "gray-light":
          return "#3d3e3eff";
        default:
          return "rgba(58, 58, 58, 1)";
      }
    }};
    cursor: not-allowed;
  }
`;

const ButtonText = styled.span`
  color: ${(props) =>
    props.variant === "gray"
      ? "rgb(33, 37, 67)"
      : props.variant === "gray-light"
      ? "rgb(33, 37, 67)"
      : props.variant === "white"
      ? "rgb(97, 98, 197)"
      : "white"};
  text-overflow: ellipsis;
  font-size: ${(props) => (props.size === "normal" ? "16px" : "14px")};
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: ${(props) => (props.size === "normal" ? "110%" : "140%")};
  text-align: left;
`;

export default Button;
